export const DIRECTION = { DOWN: "down", UP: "up" };

let scrollPos = 0;

export const scrollDirection = () => {
  const direction =
    document.body.getBoundingClientRect().top > scrollPos
      ? DIRECTION.UP
      : DIRECTION.DOWN;
  scrollPos = document.body.getBoundingClientRect().top;
  return direction;
};
